<template>
  <div class="avatar-list" :style="{'min-height':boxHeight}">
    <div class="tabbar" ref="bigBox" :style="{'width':boxWidth}">
      <a-icon type="left" class="left-icon" v-if="avatarList.length>5"   @click="handleLeft"/>
      <div class="tabbar-item" v-for="(item,index) in avatarList" :key="index" ref="BoxItem" :style="moveItem">
        <img :src="item.head" alt="" class="img">
        <div class="name">{{ item.name }}</div>
      </div>
      <a-icon type="right" class="right-icon" v-if="avatarList.length>5"  @click="handleRight"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AvatarList',
  props:{
    avatarList:{
      type:Array,required:true
    },
    width:{
      type:Number,default:410
    },height:{
      type:Number,default:140
    }
  },
  data () {
    return {
      itemWidth: 0,
      BoxWidth: 0,
      moveWidht: 0,
      currentIndex: 0,
    }
  },
  computed: {
    moveItem () {
      return  {
        transform: `translateX(${this.moveWidht}px)`
      }
    },
    boxWidth () {
      return this.width+'px' 
    },
    boxHeight () {
      return this.height+'px' 
    }
  },

  methods: {
    getTabbarWidht () {
      let itemObj = this.$refs.bigBox.getBoundingClientRect()
      this.BoxWidth = itemObj.width
    },
    getTabbarItemWidth () {
      let itemObj = this.$refs.BoxItem[0].getBoundingClientRect()
      this.itemWidth = itemObj.width
    },
    handleLeft () {
      if (this.currentIndex >0) {
        this.currentIndex--
        if(this.currentIndex == 1){
          this.moveWidht = (72 * this.currentIndex+5*this.currentIndex+10)*-1
        }else{
          this.moveWidht = (72 * this.currentIndex+5*this.currentIndex)*-1
        }
        console.log('left',this.currentIndex,this.moveItem,this.moveWidht)
      }
    },
    handleRight () {
      if (this.currentIndex < this.avatarList.length-5) {
        this.currentIndex++
        if(this.currentIndex == this.avatarList.length-5){
          this.moveWidht = (72 * this.currentIndex+5*this.currentIndex)*-1
        }else{
          this.moveWidht = (72 * this.currentIndex+5*this.currentIndex+10)*-1
        }
        console.log('right',this.currentIndex,this.moveItem,this.moveWidht)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getTabbarWidht()
      this.getTabbarItemWidth()
    })
  }
}
</script>

<style scoped lang="scss">
.avatar-list {
    margin: 0 auto;
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    position: relative;
    z-index: 9999;
.tabbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    overflow: hidden;
    padding-top: 10px;
    padding-bottom: 10px;
    .tabbar-item {
      width: 9999px;
      margin-right: 5px;
      box-sizing: border-box;
      transition: 0.5s ease;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .name {
        width: 72px;
        text-align: center;
        display: inline-block;
        line-height: 22px;
      }
      .img {
        width: 70px;
        height: 70px;
        display: inline-block;
        border-radius: 10px;
      }
    }

    .left-icon {
        width: 26px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        z-index: 9999;
        background-color: #ffffff;
        position: absolute;
        border-radius: 20px;
        border: 1px solid #333333;
        color: #333333;
        top: 45px;
        left: -25px;
        opacity: 0.4;
        cursor: pointer;
    }

    .right-icon {
      width: 26px;
      height: 26px;
      line-height: 26px;
      text-align: center;
      z-index: 9999;
      background-color: #ffffff;
      position: absolute;
      border-radius: 20px;
      border: 1px solid #333333;
      color: #333333;
      top: 45px;
      right: -25px;
      opacity: 0.4;
      cursor: pointer;
    }
    .left-icon:hover,
    .right-icon:hover{
        opacity: 0.8;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/comm/components/modal/military/content/AvatarList.vue